﻿import { RoleLevelType } from "../models/enums";

export const AuthConstants = {
    RoleLevels: [
        { id: RoleLevelType.Viewer, name: 'Viewer' },
        { id: RoleLevelType.Tech, name: 'Tech' },
        { id: RoleLevelType.TeamLead, name: 'Team Lead' },
        { id: RoleLevelType.Admin, name: 'Admin' }]
}
